import { SpaceProps, TypographyProps } from 'styled-system';

export const textSizes = {
  BIG: 'big',
  REGULAR: 'regular',
  SMALL: 'small'
} as const;

export type Sizes = typeof textSizes[keyof typeof textSizes];

export interface TextProps extends SpaceProps, TypographyProps {
  color?: string;
  fontSize?: string;
  bold?: boolean;
  size?: Sizes;
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize';
}
